import { createSlice } from '@reduxjs/toolkit';

import {
  IDirectorStep1,
  IDirectorStep1Inputs,
  IDirectorStep2,
  IDirectorStep3
} from '../types/Step';
import { checkDirectorStep1 } from './directorStep1Validations';

interface IState {
  activeStep: number;
  step1: {
    data: IDirectorStep1;
    errors: IDirectorStep1Inputs;
    isValid: boolean;
  };
  step2: IDirectorStep2;
  step3: IDirectorStep3;
}

const initialState = {
  activeStep: 1,
  step1: {
    data: {},
    errors: {},
    isValid: false
  },
  step2: {},
  step3: {}
} as IState;

export const directorRegistrationSlice = createSlice({
  name: 'directorRegistration',
  initialState,
  reducers: {
    /**
     * Обновление 1го шага регистрации
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные
     */
    updateStep1: (state, { payload }: { payload: Partial<IDirectorStep1> }) => {
      const newStep1Data = { ...state.step1.data, ...payload };
      const { isValid, errors } = checkDirectorStep1(newStep1Data);

      const newStep1 = {
        ...state.step1,
        data: newStep1Data,
        errors,
        isValid
      };

      return {
        ...state,
        step1: newStep1
      };
    },
    /**
     * Обновление 2го шага регистрации
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные
     */
    updateStep2: (state, { payload }: { payload: IDirectorStep2 }) => {
      return {
        ...state,
        step2: payload
      };
    },
    /**
     * Обновление 3го шага регистрации
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные
     */
    updateStep3: (state, { payload }: { payload: Partial<IDirectorStep3> }) => {
      return {
        ...state,
        step3: { ...state.step3, ...payload }
      };
    },
    /**
     * Обновление активного шага регистрации режиссера
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новый активный шаг
     */
    updateActiveStep: (state, { payload }: { payload: number }) => {
      return {
        ...state,
        activeStep: payload
      };
    },
    /** Удаление данных пользователя */
    reset: () => initialState
  }
});

export const {
  updateStep1: updateDirectorStep1,
  updateStep2: updateDirectorStep2,
  updateStep3: updateDirectorStep3,
  updateActiveStep: updateDirectorActiveStep,
  reset: resetDirectorRegistration
} = directorRegistrationSlice.actions;
export const { reducer: directorRegistrationReducer } =
  directorRegistrationSlice;
